
import dayjs from '../../../../util/dayjs-config';
import React, { useState } from 'react';
import SortBySelect from '../../dashboard-shared/sort-by-select/sort-by-select';
import { SORT_TYPES, SORT_TYPES_ARRAY } from '../dashboard-dynamic-fields-util';
import { GetTechnologyExport, GetTechStafferHistoricalExcelExport, GetTechStafferRawExcelExport } from '../../../../services/api/dashboard-api';
import { FluentButton } from '../../../../components/FluentUI/Fluent-Button';
import FluentUiIcon from '../../../../assets/fluent-ui-icon';
import DownloadDataModal from '../download-data-modal/download-data-modal.jsx';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";

const DashboardDynamicFieldsWidgetHeader = ({
    title,
    department,
    isModal,
    isStaffer,
    showButtons,
    sortBy,
    handleShowModal,
    handleHideModal,
    handleSelectSortBy,
    customDates,
    handleCarryOverFetch,
}) => {
    const [viewDataModal, setViewDataModal] = useState(false);

    const history = useHistory();
    const handleSelectValue = (newSortBy, newCustomDates) => {
        const datePlaceholder = 'MM/DD/YYYY';
        if (newSortBy !== SORT_TYPES.custom) {
            return newSortBy;
        }
        const { startDate, endDate } = newCustomDates;
        return `${startDate ? dayjs(startDate).format(datePlaceholder) : datePlaceholder} - ${endDate ? dayjs(endDate).format(datePlaceholder) : datePlaceholder
            }`;
    }

    const ExportExcel = async () => {
        let type = title == "Project Time Log" ? "project" : "member";
        await GetTechnologyExport(type)
            .then((res) => {
                if (res.status === 200) {
                    const link = document.createElement("a");
                    link.href = res.data;
                    link.download = "filename";
                    link.click();
                }
            })
            .catch((err) => {
                console.log("Error [GetTechnologyExport] => ", err);
            });
    };

    const ExportHistoricalData = async (startDate, endDate, selectedProjectCategories, selectedData) => {
        const payload = {
            startDate,
            endDate,
            categories: selectedProjectCategories.map(cat => cat.Id)
        };
        if (selectedData == "<GIB/Technology> Project and Member Time Log Summary") {
            try {
                const res = await GetTechStafferHistoricalExcelExport(payload);

                if (res.status === 200) {
                    const link = document.createElement("a");
                    link.href = res.data;
                    link.download = "historicalData.xlsx";
                    link.click();
                }
                return res;
            } catch (err) {
                console.log("Error [GetTechStafferHistoricalExcelExport] => ", err);
                throw err;
            }
        }
        else {
            try {
                const res = await GetTechStafferRawExcelExport(payload);

                if (res.status === 200) {
                    const link = document.createElement("a");
                    link.href = res.data;
                    link.download = "rawData.xlsx";
                    link.click();
                }
                return res;
            } catch (err) {
                console.log("Error [GetTechStafferHistoricalExcelExport] => ", err);
                throw err;
            }
        }
    };

    const techCarryOver = () => {
        handleCarryOverFetch();
    };

    return (
        <div className={`${isModal ? 'd-flex modal' : 'panel'}-header-container subDepartmentTitlePB`}>
            <h4 className="panel-title">
                {title}
                <p className="subDepartmentTitle">{department}</p>
            </h4>
            <SortBySelect
                value={handleSelectValue(sortBy, customDates)}
                handleSelect={handleSelectSortBy}
                options={SORT_TYPES_ARRAY}
                type={0}
                isMagnified={isModal}
            />
            <div className="flex-grow-1 d-flex justify-content-end align-items-center reveal-buttons">
                {!isModal &&
                    <div style={{ display: 'flex', flexDirection: 'col', gap: '10px' }} className="DashboardTableHeaderButtons">
                        <FluentButton
                            icon={<FluentUiIcon name={'ArrowClockwiseFilled'} color={'#0F6CBD'} size={20} />}
                            text="Carry Over"
                            onClick={techCarryOver}
                        />
                        {isStaffer &&
                            <FluentButton
                                icon={<FluentUiIcon name={'CalendarArrowCounterclockwiseRegular'} color={'#0F6CBD'} size={20} />}
                                text="Historical Data"
                                onClick={() => setViewDataModal(true)}
                            />
                        }
                        <FluentButton
                            icon={<FluentUiIcon name={'ArrowDownloadRegular'} color={'#0F6CBD'} size={20} />}
                            text="Export Data"
                            onClick={ExportExcel}
                        />
                        {isStaffer &&
                            <FluentButton
                                text="Create Deal"
                                appearance="secondaryWithOutline"
                                icon={
                                    <FluentUiIcon
                                        name="FolderAddRegular"
                                        color={"#0F6CBD"}
                                        size={20}
                                    />
                                }
                                onClick={() => {
                                    history.push({
                                        pathname: "/projects/create",
                                        state: { fromDashboard: true },
                                    });
                                }}
                            />
                        }
                        
                    </div>
                }
                {/*Removing "more button" => could be reused later*/}
                {/* <button className="more header-button" /> */}
                {isModal && <button className="exit-modal" onClick={handleHideModal} />}
            </div>
            {viewDataModal &&
                <DownloadDataModal
                    open={viewDataModal}
                    OnCancel={() => setViewDataModal(false)}
                    OnDownloadData={(startDate, endDate, selectedProjectsCategories, selectedData) =>
                        ExportHistoricalData(startDate, endDate, selectedProjectsCategories, selectedData)
                    }
                />
            }
        </div>
    );
};

export default DashboardDynamicFieldsWidgetHeader;

DashboardDynamicFieldsWidgetHeader.propTypes = {
    title: PropTypes.string.isRequired,
    department: PropTypes.string.isRequired,
    isModal: PropTypes.bool.isRequired,
    isStaffer: PropTypes.bool.isRequired,
    showButtons: PropTypes.bool.isRequired,
    sortBy: PropTypes.string.isRequired,
    handleShowModal: PropTypes.func,
    handleHideModal: PropTypes.func,
    handleSelectSortBy: PropTypes.func,
    customDates: PropTypes.object,
    handleCarryOverFetch: PropTypes.func,
};
